import { AlertCircleIcon } from './icons';
import './formError.css';

export type FormErrorVariant = 'field' | 'banner';

export interface FormErrorProps {
  /** Nothing renders when this is empty, so callers can pass a value directly. */
  message?: string | null | false;
  /** `field` sits under an input, `banner` announces a whole-form failure. */
  variant?: FormErrorVariant;
  id?: string;
  className?: string;
}

export function FormError({
  message,
  variant = 'field',
  id,
  className = '',
}: FormErrorProps) {
  if (!message) {
    return null;
  }

  const classes = ['form-error', `form-error--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} id={id} role="alert">
      <AlertCircleIcon size={variant === 'banner' ? 18 : 14} className="form-error__icon" />
      <span className="form-error__text">{message}</span>
    </span>
  );
}
